// Homepage SEO section
import imageBanner1 from '../components/common/app2soft/images/message.jpg';
import imageInfoDeveloper from '../components/common/app2soft/images/infoDeveloper.png';
import imageInfoGraph from '../components/common/app2soft/images/infoGraphic.png';


export const SectionCustom = {
  imagePosition: 'left',
  badgeTitle: 'Most Trustworthy',
  badgeBackground: 'default-badge',
  colorBackground: '',
  title: 'Custom Software Development Firm',
  description: "We guarantee you that we will be the most trustworthy and transparent nearshore software development company you could ever work with.",
  link: '#',
  textLink: 'See More'
}
// Homepage SEM section
// import imageSeo from '../components/common/005_icon.png';
export const SectionDevelopment = {
  imagePosition: 'right',
  badgeTitle: 'Nearshore Office',
  badgeBackground: 'default-badge',
  colorBackground: 'bg-white',
  title: 'Develop Custom Software',
  description: ' Let us put together the best development team you can get around with the option of having your own international nearshore office by extending your company’s borders.',
  link: '#',
  textLink: 'See More'
}

export const SectionAgile = {
  imagePosition: 'left',
  badgeTitle: 'Best Developers',
  badgeBackground: 'default-badge',
  colorBackground: '',
  title: 'Agile Software Development',
  description: 'Combining the outstanding skill sets of the best developers in town and with an agile development method you will have the high-quality fast paced development that you need.',
  link: '#',
  textLink: 'See More'
}

export const SectionMessage = {
  image: imageBanner1,
  text: ''
}

export const Stories = {
  title: `We have Real Success Stories`,
  description: 'Number of developers hired in the years',
  imgDeveloper: imageInfoDeveloper,
  imgInfoGraph: imageInfoGraph,
  lines:[
    {
      number: '30',
      text: 'Projects this year'
    },
    {
      number: '30',
      text: 'Projects this year'
    },
    {
      number: '30',
      text: 'Projects this year'
    },
    {
      number: '30',
      text: 'Projects this year'
    }
  ]
}

export const Questions = {
  title: "Questions?",
  description: `Send a email <a href='mailto:info@app2soft.com'>info@app2soft.com</a>`
}

export const SliderLayers = {
  layers:[
    {
      title: "The Costa Rica office is an essential business partner and we continue to look to them for reliable service. We greatly appreciate our association with App2Soft."
    }
  ]
}




// WEBPACK FOOTER //
// ./src/api/homeDataStatic.js